/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function Draft(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'Draft',
      'aria-hidden': true,
      focusable: false,
      width:  13 * scale,
      height: 16 * scale,
      viewBox: '0 0 13 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M3.612 13H1.006A1 1 0 0 1 0 12.004V2.996C0 2.446.448 2 .998 2H5.96L9 5v2.61zm8.657-4.785.516.517a.74.74 0 0 1 0 1.045l-.838.836-1.56-1.56.838-.838a.74.74 0 0 1 1.044 0M5 16l.961-2.52 3.146-3.145 1.56 1.56L7.52 15.04z","fill":"currentColor","fillRule":"evenodd"}))
}
